import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18334f6d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "password-action-done",
  class: "center-card center-card with-margin"
}
const _hoisted_2 = { class: "password-message" }
const _hoisted_3 = { key: 0 }

import { toRefs } from 'vue'

  import EmailSent from '@/components/Common/Images/EmailSent.vue'
  import Password from '@/components/Common/Images/Password.vue'

  interface Props {
    action: string
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    action: null
  },
  setup(__props: any) {

const props = __props as {
    action: string
  }

  

  const { action } = toRefs(props)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(action) === 'request-sent')
      ? (_openBlock(), _createBlock(EmailSent, { key: 0 }))
      : (_openBlock(), _createBlock(Password, { key: 1 })),
    _createElementVNode("div", _hoisted_2, [
      (_unref(action) === 'request-sent')
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('user.PASSWORD_SENT_EMAIL_TEXT')), 1))
        : (_openBlock(), _createBlock(_component_i18n_t, {
            key: 1,
            keypath: "user.PASSWORD_UPDATED"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: "/login" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.HERE')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
    ])
  ]))
}
}

})